<template>
  <el-breadcrumb class="app-breadcrumb" separator=">">
    <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if='item.meta.title'>
      <span v-if='index === 0' class="no-redirect">{{item.meta.title}}</span>
      <span v-else :to="item.path">{{item.meta.title}}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  created () {
    this.getBreadcrumb()
  },
  data () {
    return {
      levelList: null
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.meta.title)
      console.log(matched)
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{path: '/home', meta: { icon: 'fa fa-home fw', title: 'home' }}].concat(matched)
      }
      this.levelList = matched
    },
    ...mapActions([
      'sliderBarActiveIndex'
    ])
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    line-height: 60px;
    margin-left: 20px;
    .no-redirect {
      color: #000;
      font-weight: 560;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue